"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const Logo_1 = __importDefault(require("../../../../common/components/Header/Logo"));
const helpers_1 = require("../../../../common/helpers/helpers");
require("animate.css/animate.css");
const HandoverPageContainer = styled_components_1.default.div `
  animation-duration: ${(props) => props.fadeInContentTime * 1}s;

  background: linear-gradient(
    to top,
    ${props => helpers_1.Helpers.convertHexToRGBA(props.theme.palette.colorAppBar.main, 99)} 0%,
    ${props => helpers_1.Helpers.convertHexToRGBA(props.theme.palette.colorAppBar.main, 30)} 100%
  );

  background: linear-gradient(
    to top,
    ${props => props.theme.palette.colorAppBar.main} 0%,
    ${props => helpers_1.Helpers.lightenColor(props.theme.palette.colorAppBar.main, 70)} 100%
  );

  height: 100vh;
  overflow: hidden;

  .logo {
    height: 6vmin;
    margin-top: 4.7vmin;

    @media (orientation: portrait) {
      height: 8.5vmin;
    }
  }

  .background-ornament.bareiss {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url('/images/other/bareissTransparent.png');
  }

  .wrapper-app-info {
    padding: 2.8vw 4.2vw 0;
    display: flex;
    justify-content: space-between;

    &.hidden {
      display: none;
    }
  }

  .download-app-title {
    color: #040710;
    opacity: 0.87;
    font-weight: 700;
    letter-spacing: -1.5px;
    margin-top: 4vw;
    font-size: 6vmin;

    animation-duration: ${props => props.slideInTime * 1}s;

    @media (orientation: portrait) {
      font-size: 5.5vmin;

      @media (min-aspect-ratio: 3/4) {
        font-size: 5vmin;
      }
    }

    &.bachmair-class {
      margin-top: 2vmin;
      font-size: 4vmin;
    }
  }

  .app-benefits {
    list-style-type: disc;
  }

  @media (orientation: portrait) {
    height: 100%;
    overflow: visible;

    .wrapper-app-info {
      flex-direction: column-reverse;
      padding: 2.8vw 7.4vw 0;
    }
  }

  .text-center {
    text-align: center;
  }
`;
const AppInfo = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const Advantages = styled_components_1.default.ul `
  font-weight: 300;
  color: #040710;
  margin: 1.25vw 0;
  letter-spacing: -0.37px;
  font-size: 3.6vmin;
  padding-left: revert !important;

  @media (orientation: portrait) {
    font-size: 4.1vmin;
    line-height: 6.1vmin;
  }

  animation-duration: ${(props) => props.slideInTime * 1}s;

  .list-style {
    list-style-type: disc;

    &.bachmair-class {
      font-size: 2.8vmin;
    }
  }

  .advantage-1 {
    animation-delay: ${(props) => props.slideInTime * 0}s;
    animation-duration: ${(props) => props.slideInTime * 1}s;
  }

  .advantage-2 {
    animation-delay: ${(props) => props.slideInTime * 0.2}s;
    animation-duration: ${(props) => props.slideInTime * 1}s;
  }

  .advantage-3 {
    animation-delay: ${(props) => props.slideInTime * 0.4}s;
    animation-duration: ${(props) => props.slideInTime * 1}s;
  }

  .advantage-4 {
    animation-delay: ${(props) => props.slideInTime * 0.6}s;
    animation-duration: ${(props) => props.slideInTime * 1}s;
  }
`;
const AppDownloadWrapper = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 4vmin;

  @media (orientation: portrait) {
    margin-top: 1vmin;
  }

  animation-duration: ${(props) => props.slideInTime * 1}s;
`;
const ImagesWrapper = styled_components_1.default.div `
  height: 16.5vmin;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 1vmin;

  img {
    width: 22vmin;
  }
`;
const MockupImage = styled_components_1.default.div `
  img {
    max-width: 57.5vmin;
    animation-duration: ${(props) => props.slideInTime * 1}s;

    &.bachmair-class {
      height: 25vh;
    }
  }

  @media (orientation: portrait) {
    margin-left: 0;
    text-align: center;

    img {
      height: 41.4vh;
      width: auto;
      @media (min-aspect-ratio: 3/4) {
        height: 30vh;

        &.bachmair-class {
          height: 20vh;
        }
      }
    }
  }
`;
const QRCodeWrapper = styled_components_1.default.div `
  background-color: #000;
  opacity: 70;
  height: 16.4vmin;
  border: 1.5vmin solid #000000;
  border-radius: 1.2vmin;

  canvas {
    height: 13.4vmin !important;
    width: 13.4vmin !important;
    border: 2px solid white;
  }
`;
const SLIDE_IN_CONTENT_TIME = 1 * 1000;
const SLIDE_OUT_CONTENT_TIME = 1 * 1000;
const HandoverPage = (props) => {
    const { content, openNextSlide, settings, deepLink, setCurrentSlideDuration, brandInfo } = props;
    const { speed, fadeInContentTime } = settings;
    const { stopAnimationsInSlide } = settings;
    const fadeInTimeout = (0, react_1.useRef)(null);
    const slideInTimeout = (0, react_1.useRef)(null);
    const displaySlideTimeout = (0, react_1.useRef)(null);
    const slideOutTimeout = (0, react_1.useRef)(null);
    let viewportOrientation = 'landscape';
    const clearTimeouts = () => {
        clearTimeout(fadeInTimeout.current);
        clearTimeout(slideInTimeout.current);
        clearTimeout(displaySlideTimeout.current);
        clearTimeout(slideOutTimeout.current);
    };
    // detect viewport orientation
    if (window.innerHeight > window.innerWidth) {
        viewportOrientation = 'portrait';
    }
    (0, react_1.useEffect)(() => () => {
        clearTimeouts();
    }, []);
    const handleNextSlide = () => {
        // console.log( "open next slide" );
        if (!settings.stopSlideShow && !props.isDsInteractive) {
            openNextSlide();
        }
    };
    // third
    const slideOutContent = () => {
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('download-app-title')[0].classList.add('animate__fadeOutLeft');
            document.getElementsByClassName('advantages-list')[0].classList.add('animate__fadeOutLeft');
            document.getElementsByClassName('download-wrapper')[0].classList.add('animate__fadeOutLeft');
            document.getElementsByClassName('mockup-image')[0].classList.add('animate__fadeOutRight');
        }
        slideOutTimeout.current = setTimeout(() => {
            handleNextSlide();
        }, SLIDE_OUT_CONTENT_TIME / speed);
    };
    // second
    const displayContent = () => {
        displaySlideTimeout.current = setTimeout(() => {
            slideOutContent();
        }, settings.changeSlideInterval);
    };
    // first
    const slideInContent = () => {
        document.getElementsByClassName('wrapper-app-info')[0].classList.remove('hidden');
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('download-app-title')[0].classList.add('animate__fadeInLeft');
            document.getElementsByClassName('advantage-1')[0].classList.add('animate__fadeInLeft');
            document.getElementsByClassName('advantage-2')[0].classList.add('animate__fadeInLeft');
            document.getElementsByClassName('advantage-3')[0].classList.add('animate__fadeInLeft');
            document.getElementsByClassName('advantage-4')[0].classList.add('animate__fadeInLeft');
            document.getElementsByClassName('download-wrapper')[0].classList.add('animate__fadeInLeft');
            document.getElementsByClassName('mockup-image')[0].classList.add('animate__fadeInRight');
        }
        slideInTimeout.current = setTimeout(() => {
            displayContent();
        }, SLIDE_IN_CONTENT_TIME / speed);
    };
    (0, react_1.useEffect)(() => {
        clearTimeouts();
        if (!props.isDsInteractive) {
            i18n_js_1.default.locale = content.languageSelected;
            setCurrentSlideDuration(fadeInContentTime +
                SLIDE_IN_CONTENT_TIME / speed +
                settings.changeSlideInterval +
                SLIDE_OUT_CONTENT_TIME / speed);
        }
        fadeInTimeout.current = setTimeout(() => {
            slideInContent();
        }, fadeInContentTime);
    }, [content]);
    // without this class animations do not trigger
    const mainAnimationClass = stopAnimationsInSlide ? '' : 'animate__animated';
    const isPartOfTuiBlueBrands = !!brandInfo.brand.slug.includes('tui-blue');
    const isPartOfBachmairWeissach = !!brandInfo.brand.slug.includes('bachmair-weissach');
    const bachmairClass = isPartOfBachmairWeissach ? 'bachmair-class' : '';
    const bareissClass = brandInfo && brandInfo.brand.slug === 'bareiss' ? 'bareiss' : '';
    return (react_1.default.createElement(HandoverPageContainer, { className: "handover-page-container animate__animated animate__fadeIn", fadeInContentTime: fadeInContentTime / 1000, slideInTime: SLIDE_IN_CONTENT_TIME / speed / 1000 },
        react_1.default.createElement(material_1.Box, { className: `background-ornament ${bareissClass} ${mainAnimationClass}` },
            !props.isDsInteractive && (react_1.default.createElement(material_1.Box, { className: "text-center" },
                react_1.default.createElement(Logo_1.default, { className: "logo" }))),
            react_1.default.createElement(material_1.Box, { className: `wrapper-app-info hidden` },
                react_1.default.createElement(AppInfo, null,
                    !props.appStoreBannersDisabled ? (react_1.default.createElement(material_1.Typography, { variant: "h1", className: `${mainAnimationClass} download-app-title ${bachmairClass}` }, i18n_js_1.default.t('ds_download_app_title', {
                        appName: isPartOfTuiBlueBrands ? 'BLUE' : brandInfo.brand.name,
                    }))) : (react_1.default.createElement(material_1.Typography, { variant: "h1", className: `${mainAnimationClass} download-app-title ${bachmairClass}` }, i18n_js_1.default.t('DS_handover_slide_check_out_webapp', {
                        appName: isPartOfTuiBlueBrands ? 'BLUE' : brandInfo.brand.name,
                    }))),
                    react_1.default.createElement(Advantages, { className: `${mainAnimationClass} advantages-list` },
                        react_1.default.createElement("li", { className: `${mainAnimationClass} animate__fadeInLeft advantage-1 list-style ${bachmairClass}` },
                            ' ',
                            i18n_js_1.default.t('ds_advantage_hotel_info')),
                        react_1.default.createElement("li", { className: `${mainAnimationClass} animate__fadeInLeft advantage-2 list-style ${bachmairClass}` }, isPartOfTuiBlueBrands ? i18n_js_1.default.t('ds_advantage_program_tui_blue') : i18n_js_1.default.t('ds_advantage_program')),
                        react_1.default.createElement("li", { className: `${mainAnimationClass} animate__fadeInLeft advantage-3 list-style ${bachmairClass}` },
                            ' ',
                            i18n_js_1.default.t('ds_advantage_registration'),
                            ' '),
                        react_1.default.createElement("li", { className: `${mainAnimationClass} animate__fadeInLeft advantage-4 list-style ${bachmairClass}` }, isPartOfTuiBlueBrands
                            ? i18n_js_1.default.t('ds_advantage_downloadable_tui_blue')
                            : i18n_js_1.default.t('ds_advantage_downloadable'))),
                    react_1.default.createElement(AppDownloadWrapper, { className: `${mainAnimationClass} download-wrapper`, slideInTime: SLIDE_IN_CONTENT_TIME / speed / 1000 },
                        !props.appStoreBannersDisabled && (react_1.default.createElement(ImagesWrapper, null,
                            react_1.default.createElement("img", { src: "/images/other/app_store.png", alt: "App store" }),
                            react_1.default.createElement("img", { src: "/images/other/google_play.png", alt: "Google Play" }))),
                        react_1.default.createElement(QRCodeWrapper, null,
                            react_1.default.createElement(qrcode_react_1.default, { value: deepLink })))),
                react_1.default.createElement(MockupImage, { slideInTime: SLIDE_IN_CONTENT_TIME / speed / 1000 }, viewportOrientation === 'landscape' ? (react_1.default.createElement("img", { src: "/images/other/landscape.png", alt: "Mockup", className: `${mainAnimationClass}  mockup-image ` })) : (react_1.default.createElement("img", { src: "/images/other/portrait.png", alt: "Mockup", className: `${mainAnimationClass} mockup-image ${bachmairClass}` })))))));
};
const mapStoreToProps = store => ({
    appStoreBannersDisabled: store.getValue('appStoreBannersDisabled'),
    brandInfo: store.getValue('brandInfo'),
    deepLink: store.getValue('deeplink'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(HandoverPage);
